const globalHeroSwiper = new Swiper(".global-hero .swiper", {
	// Optional parameters
	loop: true,
	slidesPerView: 1,
	lazy: true,
	simulateTouch: false,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},

	autoplay: {
		delay: 5000
	},
	speed: 700,

	// If we need pagination
	pagination: false,

	// Navigation arrows
	navigation: {
		nextEl: ".global-hero .swiper .swiper-button-next",
		prevEl: ".global-hero .swiper .swiper-button-prev",
	},
});


var globalHeroAutoplay = true;

(function ($) {
	// On Dom Ready
	$(function () {
		// Toggle slide play/pause
		$('.global-hero .btn-play-pause').on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass("active");

			if(globalHeroAutoplay) {
				globalHeroSwiper.autoplay.stop();
				globalHeroAutoplay = false;
			}
			else{
				globalHeroSwiper.autoplay.start();
				globalHeroAutoplay = true;
			}
		});
	});

})(jQuery);

